import { createSlice } from "@reduxjs/toolkit";

const taskSlice = createSlice({
    name: "tasks",
    initialState: {
        taskList: [],
        editTaskDetails: null
    },
    reducers: {
      setTaskList: (state, action) => {
        state.taskList = action?.payload
      },
      setEditTaskDetails: (state, action) => {
        state.editTaskDetails = action?.payload
      },
      removeTaskItems: (state, action) => {
        switch(action?.payload) {
          case 'TASKS':
              state.taskList = [];
              break;
          case 'EDIT_TASK_DETAILS':
              state.editTaskDetails = null;
              break;
          default:
              break;
        }
      },
      clearTasks: (state, action) => {
        state.taskList = []
        state.editTaskDetails = null
      }
    }
  });


// this is for dispatch
export const { setTaskList, setEditTaskDetails, removeTaskItems, clearTasks } = taskSlice.actions;

// this is for configureStore
export default taskSlice.reducer;